import { render, staticRenderFns } from "./narrator.vue?vue&type=template&id=6bcf8d71&scoped=true&"
import script from "./narrator.vue?vue&type=script&lang=js&"
export * from "./narrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf8d71",
  null
  
)

export default component.exports